/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const RegisterValidationFieldName = {
    EmployeeNumber: 'EmployeeNumber',
    CostCenter: 'CostCenter'
} as const;

export type RegisterValidationFieldName = typeof RegisterValidationFieldName[keyof typeof RegisterValidationFieldName];



